import React from "react";
import { Link } from "react-router-dom";
import ruCondition from "../../assets/conditions.pdf";
import upperFirst from 'lodash/upperFirst';

class PrivacyPolicyAgreements extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      marketing: null,
      privacyPolicy: null,
      ruCondition: null,
      termsAndCondition: null,
      termsAndConditionVisible: false,
    };
  }

  onChange(event) {
    this.setState(
      {
        [event.target.name]: event.target.checked ? true : null,
      },
      () => {
        this.props.updatePrivacyPolicy({
          marketing: this.state.marketing === true,
          privacyPolicy: this.state.privacyPolicy === true,
          ruCondition: this.state.ruCondition === true,
          termsAndCondition: this.state.termsAndCondition === true,
        });
      }
    );
  }

  onTermsAndConditionClick(e) {
    e.preventDefault();
    this.setState({ termsAndConditionVisible: true });
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {this.state.termsAndConditionVisible ? (
          <>
            <div className="modal-overlay"></div>
            <div className="popup terms-condition-popup">
              <span
                className="close-modal"
                onClick={() => {
                  this.setState({ termsAndConditionVisible: false });
                }}
              >
                x
              </span>
              <h3>{t("policyAgreement:condition")}</h3>
              <ul>
                <li>{t("policyAgreement:agreementText1")}</li>
                <li>{t("policyAgreement:agreementText2")}</li>
              </ul>
              <p className="terms-and-condition-star">{t("policyAgreement:agreementText3")}</p>
            </div>
          </>
        ) : null}
        <div className="checkboxes-box">
          <label className="checkbox-box">
            {t("privacyPolicyText")}{" "}
            <Link to="/privacy-policy">{t("privacyPolicy")}</Link>
            <input
              className="checkbox"
              onChange={this.onChange.bind(this)}
              type="checkbox"
              name="privacyPolicy"
            />
            <span className="checkmark"></span>
          </label>
          {this.props.validator.message(
            "privacyPolicy",
            this.state.privacyPolicy,
            "required",
            {
              messages: {
                required: t("common:acceptedValidation", {
                  field: t("privacyPolicy"),
                }),
              },
            }
          )}
          <label className="checkbox-box">
            {t("marketingAgreementText")}
            <input
              className="checkbox"
              type="checkbox"
              onChange={this.onChange.bind(this)}
              name="marketing"
            />
            <span className="checkmark"></span>
          </label>
          <label className="checkbox-box">
            {t("termsAndConditionText")}{" "}
            <a href="/" onClick={this.onTermsAndConditionClick.bind(this)}>
              {t("termsAndCondition")}
            </a>
            <input
              className="checkbox"
              onChange={this.onChange.bind(this)}
              type="checkbox"
              name="termsAndCondition"
            />
            <span className="checkmark"></span>
          </label>
          {this.props.validator.message(
            "termsAndCondition",
            this.state.termsAndCondition,
            "required",
            {
              messages: {
                required: t("common:acceptedValidation", {
                  field: upperFirst(t("termsAndCondition")),
                }),
              },
            }
          )}
          {this.props.i18n.language === "ru" && (
            <>
              <label className="checkbox-box">
                {t("ruConditionText")}{" "}
                <a href={ruCondition} target="_blank" rel="noopener noreferrer">
                  {t("ruCondition")}
                </a>
                <input
                  className="checkbox"
                  onChange={this.onChange.bind(this)}
                  type="checkbox"
                  name="ruCondition"
                />
                <span className="checkmark"></span>
              </label>
              {this.props.validator.message(
                "ruCondition",
                this.state.ruCondition,
                "required",
                {
                  messages: {
                    required: t("common:acceptedValidation", {
                      field: t("ruCondition"),
                    }),
                  },
                }
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default PrivacyPolicyAgreements;
